var $4e538a6c4bc88518$exports = {};
$4e538a6c4bc88518$exports = {
    "colorFormat": `Spalv\u{173} formatas`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$4e538a6c4bc88518$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
